import React from 'react';
import { ISanitizer, sanitize } from '../../../commonInfra/utils/Sanitize';
import { TextileHelper } from '../../../ts/helpers/TextileHelper';
import { ServiceLocator } from '../../ServiceLocator';
import { DetailsTooltipStyles } from '../CardView/DetailsTooltipStyles';
import { ContentDescriptionClassNames } from '../Tooltips/TooltipHelper';

export interface MarkupFieldProps {
  label?: string;
  markup: string;
  testId?: string;
  extraClasses?: string[];
}

export function MarkupField(props: MarkupFieldProps) {
  const sanitizeFn = sanitize;
  const htmlContent = getSanitizedHtmlFromMarkup(props.markup, sanitizeFn);

  if (!props.markup || !htmlContent) {
    return null;
  }

  // Open anchor tag links in a new tab by default
  const $tempElement = $('<div></div>').html(htmlContent.__html);
  $tempElement.find('a').not('[target]').attr('target', '_blank');
  htmlContent.__html = $tempElement.html();

  const classes = [DetailsTooltipStyles.MetadataSection].concat(props.extraClasses).join(' ');

  return (
    <div className={classes}
         data-tb-test-id={props.testId}>

      { props.label && <div className={DetailsTooltipStyles.MultiLineTitle}>{props.label}</div> }

      <div className={ContentDescriptionClassNames}
           dangerouslySetInnerHTML={htmlContent} />

    </div>
  );
}

function getSanitizedHtmlFromMarkup(
  markup: string,
  sanitizeFn: ISanitizer
): { __html: string } {
  return { __html: TextileHelper.getSanitizedHtmlFromTextile(markup, sanitizeFn) };
}
